import { Component } from "../Component";
import {element} from "../CustomElement";
import { Page } from "../flipp-page/Page";
import {i18n} from "../../i18n/I18n";
import {Flyer} from "../../definitions/FlyerDefinitions";
import {Coupon} from "../../definitions/CouponDefinitions";
import {friendlyValidity} from "../../i18n/I18n";
import {FlyerService} from "../../services/FlyerService";
import {CouponService} from "../../services/CouponService";
import {LinkService} from "../../services/LinkService";
import {SeoService} from "../../services/SeoService";
import {UserAgentService} from "../../services/UserAgentService";
import {inject} from "../../services/di";
import {LazyImage} from "../../components/flipp-lazy-image/LazyImage";
import {CouponPageHeader} from "../../components/flipp-coupons-page/CouponsPage";
import {CouponClipping} from "../../components/flipp-coupon-clipping/CouponClipping";
import { isCrawler } from "../../utils/crawler";

type FlyersCoupons = [Flyer[], Coupon[]];

@element("flipp-city-homepage")
export class CityHomepage extends Component<{}, FlyersCoupons> {

	@inject couponService: CouponService;
	@inject flyerService: FlyerService;
	@inject linkService: LinkService;
	@inject userAgent: UserAgentService;
	@inject seoService: SeoService;

	refs: {
		[key: string]: any,
		flyerButton: HTMLElement,
		couponButton: HTMLElement,
		coupons: HTMLElement,
		flyers: HTMLElement,
		spinner: HTMLElement,
		flyerContainer: HTMLElement
	};

	async prepare()  {
		const flyers = await this.flyerService.getFlyers();
		const coupons = await this.couponService.getSortedCoupons();
		return [flyers, coupons] as FlyersCoupons;
	}

	renderFlyers(flyers: Flyer[]): HTMLElement {
		this.seoService.insertLoadingMarker(70);
		const spinnerClass = "spinner-wrapper" + (isCrawler() ? "" : " show");
		const flyerContainerClass = "premium-flyer-container" + (isCrawler() ? "" : " city-flyer-hidden");
		return (
			<div class="merchant-main-wrapper">
				{flyers.slice(0, 20).map((flyer: any, index: number) => {
					return <div class="merchant-item">
						<section ref="spinner" class={spinnerClass}>
							<div class="loading">
								<div class="spinner"></div>
							</div>
						</section>
						<a
							ref="flyerContainer"
							class={flyerContainerClass}
							href={this.linkService.linkTo(flyer)}
						>
							<div class="merchant-item-img" data-index={index.toString()}>
								<LazyImage
									alt={flyer.merchant}
									fit
									contain
									dataSrc={flyer.thumbnailPremium}
									onload={this.hideImageSpinner}
								/>
							</div>
							<div class="flyer-info">
								<LazyImage
									class="logo"
									alt={flyer.getName()}
									fit
									contain
									dataSrc={flyer.merchantLogo}
								/>
								<div class="flyer-info-block">
									<p class="flyer-name">{flyer.getName()}</p>
									<p>{friendlyValidity(new Date(flyer.validFrom), new Date(flyer.validTo))}</p>
								</div>
							</div>
						</a>
					</div>;
				})}
			</div>
		);
	}

	renderCoupons(coupons: Coupon[]): HTMLElement {
		return (
			<div class="coupons-wrapper">
				{coupons.slice(0, 20).map((coupon: any) => {
					return <CouponClipping couponId={coupon.id} />;
				})}
			</div>
		);
	}

	render(data: FlyersCoupons) {
		const [flyers, coupons] = data;
		return (
			<Page show="flyers">
				<div class="button-tabs">
					<button onClick={this.handleSort} ref="flyerButton" sort="flyers" class="buttons underlined">{i18n("top_flyers")}</button>
					<button onClick={this.handleSort} ref="couponButton" sort="coupons" class="buttons">Top Coupons</button>
				</div>
				<section ref="coupons" class="sections hidden" id="city-homepage-top-coupons">
					<header class="intro">
						<CouponPageHeader />
					</header>
					{this.renderCoupons(coupons)}
				</section>
				<section ref="flyers" class="sections" id="city-homepage-top-flyers">
					{this.renderFlyers(flyers)}
				</section>
			</Page>
		);
	}

	private handleSort = (e: any) => {
		if (e.target.textContent === "Top Coupons" && this.userAgent.mobile) {
			this.linkService.execute(this.linkService.linkTo("install", {
				feature: "coupons"
			}), this);
			return;
		}
		e.stopPropagation();
		const buttons = document.querySelectorAll(".buttons");
		const sections = document.querySelectorAll(".sections");
		for (let i = 0; i < buttons.length; i++) {
			buttons[i].classList.remove("underlined");
			sections[i].classList.add("hidden");
		}
		e.target.classList.add("underlined");
		const sortType = e.target.getAttribute("sort");
		this.refs[sortType].classList.remove("hidden");
	}

	private hideImageSpinner = (e: any) => {
		const spinners = document.querySelectorAll(".spinner-wrapper");
		const flyers = document.querySelectorAll(".premium-flyer-container");
		const imageIndex = +e.currentTarget.parentNode.getAttribute("data-index");
		flyers[imageIndex].classList.remove("city-flyer-hidden");
		spinners[imageIndex].classList.remove("show");
	}
}
